import moment from "moment";

// Round once to whole minutes before splitting so e.g. 59m30s reads "1h0m", not "0h0m"
export const formatDuration = time => {
  const totalMinutes = Math.round(moment.duration(time).asMinutes());
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return hours > 0 ? hours + "h" + minutes + "m" : minutes + "m";
};
